const messages = {
  en: {
    translations: {
      signup: {
        title: "Sign up",
        toasts: {
          success: "User created successfully! Please login!",
          fail: "Error creating user. Check the reported data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      auth: {
        toasts: {
          success: "Login successfully!",
          expired: "Your session has expired. Please sign in again.",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets today: ",
          },
        },
        messages: {
          inAttendance: {
            title: "In Service"
          },
          waiting: {
            title: "Waiting"
          },
          closed: {
            title: "Closed"
          }
        }
      },
      connections: {
        title: "Connections",
        toasts: {
          deleted: "Connection deleted successfully!",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? It cannot be reverted.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You'll need to read QR Code again.",
        },
        canais: {
          whatsapp: "WhatsApp",
          whatsappOficial: "WhatsApp Official API",
          whatsappVoz: "WhatsApp (voice)",
          telegram: "Telegram",
          facebook: "Facebook",
          instagram: "Instagram",
          redeSocial: "Social network",
          viaZernio: "{{canal}} (Zernio)",
          canaisDaMeta:
            "Facebook, Instagram and WhatsApp Official API are added through their own buttons, next to “Add channel”.",
        },
        buttons: {
          add: "Add channel",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          connecting: "Connectiing",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
          },
          qrcode: {
            title: "Waiting for QR Code read",
            content:
              "Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
          },
          connected: {
            title: "Connection established",
          },
          timeout: {
            title: "Connection with cell phone has been lost",
            content:
              "Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
          },
        },
        table: {
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
        },
      },
      whatsappModal: {
        title: {
          add: "Add WhatsApp",
          edit: "Edit connection",
        },
        form: {
          name: "Name",
          default: "Default",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Connection saved successfully.",
      },
      qrCode: {
        message: "Read QrCode to start the session",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted sucessfully!",
        },
        searchPlaceholder: "Search ...",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related tickets will be lost.",
          importMessage: "Do you want to import all contacts from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
        },
        table: {
          name: "Name",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "Whatsapp number",
          email: "Email",
          extraName: "Field name",
          extraValue: "Value",
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
      },
      quickAnswersModal: {
        title: {
          add: "Add Quick Reply",
          edit: "Edit Quick Answer",
        },
        form: {
          shortcut: "Shortcut",
          message: "Quick Reply",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Quick Reply saved successfully.",
      },
      queueModal: {
        title: {
          add: "Add queue",
          edit: "Edit queue",
        },
        form: {
          name: "Name",
          color: "Color",
          greetingMessage: "Greeting Message",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      userModal: {
        title: {
          add: "Add user",
          edit: "Edit user",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          profile: "Profile",
          whatsapp: "Default Connection",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "User saved successfully.",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        toasts: {
          deleted: "The ticket you were on has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search tickets and messages.",
        },
        buttons: {
          showAll: "All",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to queue",
        fieldConnectionLabel: "Transfer to connection",
        fieldQueuePlaceholder: "Please select a queue",
        fieldConnectionPlaceholder: "Please select a connection",
        noOptions: "No user found with this name",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        pendingHeader: "Queue",
        assignedHeader: "Working on",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage: "No tickets found with this status or search term.",
        connectionTitle: "Connection that is currently being used.",
        buttons: {
          accept: "Accept",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          tickets: "Tickets",
          contacts: "Contacts",
          quickAnswers: "Quick Answers",
          queues: "Queues",
          tags: "Tags",
          administration: "Administration",
          users: "Users",
          settings: "Settings",
        },
        appBar: {
          user: {
            profile: "Profile",
            logout: "Logout",
          },
        },
      },
      notifications: {
        noTickets: "No notifications.",
      },
      queues: {
        title: "Queues",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting message",
          actions: "Actions",
        },
        buttons: {
          add: "Add queue",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.",
        },
      },
      queueSelect: {
        inputLabel: "Queues",
      },
      tags: {
        title: "Tags",
        table: {
          name: "Name",
          color: "Color",
          actions: "Actions",
        },
        buttons: {
          add: "Add tag",
        },
        toasts: {
          deleted: "Tag deleted successfully!",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? It cannot be reverted! Tickets with this tag will still exist, but will not have this tag assigned.",
        },
      },
      tagModal: {
        title: {
          add: "Add tag",
          edit: "Edit tag",
        },
        form: {
          name: "Name",
          color: "Color",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Tag saved successfully!",
      },
      tagSelect: {
        inputLabel: "Tags",
      },
      quickAnswers: {
        title: "Quick Answers",
        table: {
          shortcut: "Shortcut",
          message: "Quick Reply",
          actions: "Actions",
        },
        buttons: {
          add: "Add Quick Reply",
        },
        toasts: {
          deleted: "Quick Reply deleted successfully.",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Quick Reply: ",
          deleteMessage: "This action cannot be undone.",
        },
      },
      users: {
        title: "Users",
        table: {
          name: "Name",
          email: "Email",
          profile: "Profile",
          whatsapp: "Default Connection",
          actions: "Actions",
        },
        buttons: {
          add: "Add user",
        },
        toasts: {
          deleted: "User deleted sucessfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Users' open tickets will be moved to queue.",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        settings: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Type a message or press ''/'' to use the registered quick responses",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
      },
      contactDrawer: {
        header: "Contact details",
        buttons: {
          edit: "Edit contact",
        },
        extraInfo: "Other information",
      },
      ticketOptionsMenu: {
        delete: "Delete",
        transfer: "Transfer",
        confirmationModal: {
          title: "Delete ticket #",
          titleFrom: "from contact ",
          message: "Attention! All ticket's related messages will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be reverted.",
        },
      },
      backendErrors: {
        ERR_NO_STATUS_POST_FOUND:
          "This status no longer exists or belongs to another company.",
        ERR_STATUS_NAO_ENCONTRADO:
          "This status no longer exists.",
        ERR_STATUS_ALREADY_PUBLISHED:
          "This status was already published. Only the flow can be changed now; to change the rest, create a new one from it.",
        ERR_STATUS_JA_PUBLICANDO:
          "This status is already being published. Wait a few seconds.",
        ERR_STATUS_AUDIENCE_REQUIRED:
          "Choose at least one contact or tag in “Who sees it”.",
        ERR_STATUS_AUDIO_NAO_SUPORTADO:
          "This connection can't publish audio statuses. Use text, image or video, or another connection.",
        ERR_STATUS_CANAL_NAO_SUPORTADO:
          "This connection can't publish statuses. Choose a WhatsApp connection that does.",
        ERR_STATUS_INVALID_FLOW:
          "The chosen flow no longer exists. Choose another or leave it without a flow.",
        ERR_STATUS_INVALID_NAME:
          "Give the status a name (at least 2 characters).",
        ERR_STATUS_INVALID_WHATSAPP:
          "Choose a valid connection to publish the status.",
        ERR_STATUS_MEDIA_REQUIRED:
          "Upload the status file before saving.",
        ERR_STATUS_SEM_DESTINATARIOS:
          "No contact matches “Who sees it”: the status would have no one to show to.",
        ERR_STATUS_SEM_MIDIA:
          "This status file was not found. Upload it again.",
        ERR_STATUS_TEXT_REQUIRED:
          "Write the status text.",
        ERR_WAHA_SEM_BASE_URL:
          "WhatsApp v2 has no server address. Pick a server on the connection or contact support.",
        ERR_WAHA_SEM_API_KEY:
          "WhatsApp v2 is missing the server access key. Pick a server on the connection or contact support.",
        ERR_WAHA_SEM_URL_DE_WEBHOOK:
          "The system's public address is missing from the server configuration — without it WhatsApp v2 has nowhere to deliver messages. Contact support.",
        ERR_WAHA_STATUS_SEM_DESTINATARIOS:
          "Choose who to publish the status to. With nobody on the list, it is not published.",
        ERR_WAHA_MIDIA_SEM_CONTEUDO:
          "The file arrived empty and was not sent. Attach it again.",
        ERR_WAHA_ARQUIVO_GRANDE:
          "The file is larger than WhatsApp v2 accepts.",
        ERR_WAHA_ARQUIVO_FORA_DE_ROTA:
          "The file could not be downloaded from WhatsApp v2.",
        ERR_UAZAPI_SEM_BASE_URL:
          "WhatsApp v3 has no server address. Pick a server on the connection or contact support.",
        ERR_UAZAPI_ARQUIVO_GRANDE:
          "The file is larger than WhatsApp v3 accepts.",
        ERR_UAZAPI_MIDIA_VAZIA:
          "WhatsApp v3 delivered the file empty. Ask the customer to send it again.",
        ERR_SUBSCRIPTION_OVERDUE:
          "Subscription overdue: access is blocked until payment is confirmed. Open Billing > Invoices to pay.",
        ERR_SUBSCRIPTION_BLOCKED:
          "Subscription blocked. Access has been suspended for this company — contact the account administrator.",
        ERR_SUBSCRIPTION_OVERDUE_NEW_TICKETS:
          "Subscription overdue: you cannot open new tickets. Ongoing tickets keep working. Open Billing > Invoices to settle it.",
        ERR_MODULE_NOT_CONTRACTED:
          "This feature is not part of your plan. Contact the account administrator to add it.",
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_INVALID_ACCESS_SETTINGS:
          "Invalid access settings. Check schedule, IPs, session limit and scope.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_PLAN_REQUIRED:
          "Choose a plan to create the account.",
        ERR_PLAN_NOT_AVAILABLE:
          "This plan is no longer for sale. Reload the page and choose another.",
        ERR_PLAN_LIMIT_STATUS:
          "You have already published every status your plan allows this month.",
        ERR_CONTA_DO_PAINEL_DE_STATUS:
          "This account belongs to the Status panel. Sign in at {{endereco}}.",
        ERR_CONTA_DO_PAINEL_PRINCIPAL:
          "This account does not belong to the Status panel. Sign in at the main panel, {{endereco}}.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_SESSAO_VINCULADA_FORA_DO_AR:
          "The session linked to this official connection is offline, and the fallback is set to not send through the Official API. Reconnect the session or change the fallback on the connection.",
        ERR_CHANNEL_SERVER_NOT_FOUND:
          "No channel server found with this ID.",
        ERR_CHANNEL_SERVER_INVALID_PROVIDER:
          "This provider does not accept a dedicated server.",
        ERR_CHANNEL_SERVER_INVALID_NAME: "Enter a name for the server.",
        ERR_CHANNEL_SERVER_INVALID_URL:
          "Invalid address — it must start with http:// or https://.",
        ERR_CHANNEL_SERVER_INVALID_TOKEN: "Enter the server token.",
        ERR_CHANNEL_SERVER_IN_USE:
          "Connections are using this server. Point them elsewhere before deleting it.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
      },
    },
  },
};

export { messages };
